export default {
    name: 'pure',
    override: {
    }
  };
  